module.exports = __webpack_public_path__ + "static/media/about-feira2.3a375242.jpg";